(function () {

    var jsFrameworksOverviewSlider = document.getElementsByClassName("js-frameworks-overview-slider");

    if (!jsFrameworksOverviewSlider.length)
        return;

    var tabList = document.getElementsByClassName("js-frameworks-overview-slider__tabs"),
        tilesList = document.getElementsByClassName("js-frameworks-overview-slider__tiles");

    // loop through the tabs list to get the buttons
    for (var i = 0; i < tabList[0].children.length; i++) {
        (function () {
            var tab = tabList[0].children[i];

            tab.addEventListener('click', function () {
                // clicking the open tab closes it again, so work out the
                // resulting state before anything is reset
                var willOpen = !(tab.getAttribute('aria-selected') == 'true');

                // close all sliders
                closeSlide(tilesList);
                // update the aria — only ever one tab selected at a time
                focusTab(tab, willOpen);
                // open the tile
                openSliderTile(tab);
            });
        }());
    }

    // used to focus the tabs. Deselects every tab first so the selected
    // underline can't stack up across tabs.
    function focusTab(elem, selected) {
        for (var i = 0; i < tabList[0].children.length; i++) {
            tabList[0].children[i].setAttribute('aria-selected', 'false');
        }

        elem.setAttribute('aria-selected', selected);
    }

    // close all the slides
    function closeSlide(tilesList) {
        for (var i = 0; i < tilesList[0].children.length; i++) {
            (function () {
                var tile = tilesList[0].children[i];

                if (tile.classList.contains('open')) {
                    tile.classList.remove('open');

                }
            }());
        }
    }

    // open the single tile
    function openSliderTile(elem) {
        // grab the tile
        var tileElem = document.getElementById(elem.getAttribute('aria-controls'));

        // check if the tile has the open class
        if (!tileElem.classList.contains('open')) {
            tileElem.classList.add('open');

        } else {
            tileElem.classList.remove('open');

        }
    }

}());
